import './videos.css';

const VideoLibrary = () => {
  return (
    <section className="video-library">
      <div className="video-library__header">
        <p className="video-library__eyebrow">On-demand</p>
        <h1 className="video-library__title">Class Recordings</h1>
        <p className="video-library__sub">
          Missed a class or want to revisit a sequence? Rent or subscribe to watch anytime.
        </p>
      </div>
      <div className="video-library__embed">
        <iframe
          src="https://florium.studio/iy-sp/videos/embed"
          title="Video Library"
          allowpaymentrequest="true"
          allow="fullscreen; autoplay; picture-in-picture; payment"
          allowFullScreen
        />
      </div>
    </section>
  );
};

export default VideoLibrary;
